// empty-stablelib-random.js
module.exports = {
  randomBytes: function () {
    let length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 32;
    return new Uint8Array(length);
  },
  randomInt: () => {
    return 0;
  }
};